import type { RenterPaymentMethodTypeInterface } from './Types';

const PaymentMethodTypesModel = (paymentMethodTypes: Array<RenterPaymentMethodTypeInterface>) =>
  paymentMethodTypes.map((paymentMethodType) => {
    const { name = '', type = '', rentFee = '', otherFee = '' } = paymentMethodType;

    return {
      name,
      type,
      rentFee,
      otherFee,
    };
  });

export default PaymentMethodTypesModel;
